import type { ClassId } from '../types';

export const CLASS_NAME_MAP: Record<ClassId, string> = {
  'arcane-trickster': 'Arcane Trickster',
  artificer: 'Artificer',
  bard: 'Bard',
  cleric: 'Cleric',
  druid: 'Druid',
  'eldritch-knight': 'Eldritch Knight',
  paladin: 'Paladin',
  ranger: 'Ranger',
  sorcerer: 'Sorcerer',
  warlock: 'Warlock',
  wizard: 'Wizard',
};
